export const PRIMARY_COLOR =  "#a32a29"
export const SECONDARY_COLOR =  "#9b2524"